import React from 'react';
import moment from 'moment';
import Loading from '../../common/loading/Loading';
import Responsive from '../../common/responsive/Responsive';
import { withComponentId } from './../../common/ComponentIdContext';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { changeFilter, fetchDataSnapshotSearch, REDUCER_NAME } from './reducer';
import { I18n } from 'react-redux-i18n';
import Const from './Const';
import Tab from './../../common/tab-timer';
import MixChart from '../../common/mixChart/MixChart';
import { cloneDeep } from 'lodash';

const KEY_PREV_ITEM = 'PrevItem';
const _format = require('string-format');
_format.extend(String.prototype, {});

const MD_SIZE = 1500;
const SM_SIZE = 1000;
const XS_SIZE = 520;

class Chart extends React.Component {
  componentDidMount() {
    localStorage.removeItem(KEY_PREV_ITEM);
  }

  handleChecked = (key, eventName, isMouseMove) => {
    let prev = localStorage.getItem(KEY_PREV_ITEM);
    key.isMouseMove = isMouseMove;

    const event = new CustomEvent(eventName, { detail: key });
    if (!isMouseMove) {
      localStorage.removeItem(KEY_PREV_ITEM);
      window.dispatchEvent(event);
    } else if (prev !== key.currentItem.category.toString()) {
      localStorage.setItem(KEY_PREV_ITEM, key.currentItem.category);
      window.dispatchEvent(event);
    }
  };

  getDataItemByTimeFilter = dataItem => {
    const { timeFilter } = this.props;

    let data = dataItem.yearly;
    if (timeFilter === 1) {
      data = dataItem.quarterly;
    }

    return data;
  };

  calcColumn = () => {
    const { width } = this.props;
    if (width > MD_SIZE) {
      return 4;
    }

    if (width > SM_SIZE) {
      return 3;
    }

    if (width > XS_SIZE) {
      return 2;
    }

    return 1;
  };

  getListBarChart = () => {
    const { width, currentSearch } = this.props;
    if (currentSearch && currentSearch.isBanking) {
      return Const.listBarChart.listBarChartBanking;
    }
    if (width === 0) {
      return Const.listBarChart.listBarChartNonBankingOneColumn;
    }
    const mapListBarChart = {
      1: Const.listBarChart.listBarChartNonBankingOneColumn,
      2: Const.listBarChart.listBarChartNonBankingTwoColumn,
      3: Const.listBarChart.listBarChartNonBankingThreeColumn,
      4: Const.listBarChart.listBarChartNonBankingFourColumn,
    };

    return mapListBarChart[this.calcColumn()];
  };

  getCfaStatus = dataChart => {
    const length = dataChart.length;

    return length > 2 &&
      dataChart[length - 1].cfa10 === 0 &&
      dataChart[length - 1].cfa11 === 0 &&
      dataChart[length - 1].cfa12 === 0 &&
      dataChart[length - 2].cfa10 === 0 &&
      dataChart[length - 2].cfa11 === 0 &&
      dataChart[length - 2].cfa12 === 0
      ? 0
      : 1;
  };

  formatDataChart = (data, cfaStatus) => {
    const result = [];

    data.forEach(item => {
      const newItem = cloneDeep(item);

      if (cfaStatus === 0) {
        newItem.cfa10 = item.bsa9;
        newItem.cfa11 = item.bsa16;
        newItem.cfa12 = item.bsa57;
      }

      newItem.commonCfaStatus = cfaStatus;
      result.push(newItem);
    });

    return result;
  };

  renderListBarChart = () => {
    const { data = [], component = {}, componentId: id, width } = this.props;
    const unix = moment().unix();

    return data.map((dataItem, index) => {
      const dataFollowTime = this.getDataItemByTimeFilter(dataItem);

      const cfaStatus = this.getCfaStatus(dataFollowTime);

      const dataChart = this.formatDataChart(dataFollowTime, cfaStatus);

      const listBarChart = this.getListBarChart();
      return (
        <div
          className="cast-chart w-100"
          key={'cast-chart' + unix + id + index}
        >
          <Responsive
            component={{
              ...component,
              width: Math.max(component.width, width + 40),
            }}
            key={'component-chart' + unix + id + index}
            margin={10}
            offsetWidth={76}
            XS_SIZE={520}
          >
            {listBarChart.map(item => {
              return (width, height) => (
                <MixChart
                  idComponent={id}
                  data={dataChart}
                  configChart={item.configChart}
                  width={width}
                  height={height}
                  ratio={window.devicePixelRatio}
                  handleChecked={this.handleChecked}
                  cfaStatus={cfaStatus}
                />
              );
            })}
          </Responsive>
        </div>
      );
    });
  };

  changeTab = timeFilter => {
    const { changeFilter, componentId } = this.props;

    changeFilter(timeFilter, componentId);
  };

  render() {
    const { timeFilter = 2, isLoading } = this.props;

    return (
      <div className="snapShot-chart">
        {isLoading && <Loading />}
        <div className={isLoading ? 'bg-blur' : ''}>
          <div className="snapShot-FinancialPer">
            <span className="snapShot-titleFinancialPer font-weight-bold">
              {I18n.t('snapShot.titleFinancialPerformance')}
            </span>
            <div className="snapShot-FinancialPer-tab">
              <Tab
                disableTabNormal={false}
                currentTab={timeFilter}
                listTab="snapShot.timeTab"
                changeTab={this.changeTab}
              />
            </div>
          </div>
          {this.renderListBarChart()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    componentId,
    i18n: state.i18n,
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
    data: state[REDUCER_NAME].listMultiComponent[componentId].data,
    component: state[REDUCER_NAME].listMultiComponent[componentId].component,
    timeFilter: state[REDUCER_NAME].listMultiComponent[componentId].timeFilter,
    isLoading:
      state[REDUCER_NAME].listMultiComponent[componentId].isChartLoading,
  };
};

const mapDispatchToProps = {
  changeFilter,
  fetchDataSnapshotSearch,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Chart);
